import { Link } from 'react-router-dom';

const GUIDES = [
  {
    icon: 'ri-key-line',
    title: 'Vacation Rentals in Highlands, NC',
    desc: 'A focused guide to whole-home vacation rentals in Highlands — ranked by guest ratings and location.',
    link: '/vacation-rentals-highlands-nc',
    label: 'View Guide',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Cabins in Highlands, NC',
    desc: 'The complete guide to cabin rentals in Highlands, North Carolina — from luxury retreats to cozy mountain escapes.',
    link: '/cabins-in-highlands-nc',
    label: 'View Guide',
  },
  {
    icon: 'ri-footprint-line',
    title: 'Pet Friendly Cabins in Highlands, NC',
    desc: 'Traveling with a dog? This guide covers the best pet-friendly cabin rentals in Highlands, NC.',
    link: '/pet-friendly-cabins-highlands-nc',
    label: 'View Guide',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Things to Do in Highlands, NC',
    desc: 'Waterfalls, hiking, restaurants, and more — a local guide to the best activities in Highlands, North Carolina.',
    link: '/things-to-do',
    label: 'Explore Activities',
  },
];

export default function PTSRelatedGuidesSection() {
  return (
    <section className="bg-[#FAFAF8] py-20 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ More Guides</p>
          <h2 className="font-cormorant text-4xl text-[#1A1A18] font-light">
            Related Guides for<br /><em className="italic">Highlands, NC</em>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {GUIDES.map((g) => (
            <Link
              key={g.title}
              to={g.link}
              className="bg-white rounded-2xl p-7 flex flex-col gap-4 hover:bg-[#F5F1EB] transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] group-hover:bg-[#D4DDD8] transition-colors">
                <i className={`${g.icon} text-[#2D4A3E] text-base`} />
              </div>
              <div>
                <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-2 leading-snug">{g.title}</h3>
                <p className="text-[#5C5850] font-jost text-xs leading-relaxed mb-4">{g.desc}</p>
                <span className="text-[#2D4A3E] text-xs font-jost font-medium tracking-wide flex items-center gap-1.5">
                  {g.label}
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
